
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-parlament-catalunya-2021/on-han-votat-mes-a-cada-partit",
      function () {
        return require("private-next-pages/3catinfo/eleccions-parlament-catalunya-2021/on-han-votat-mes-a-cada-partit/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-parlament-catalunya-2021/on-han-votat-mes-a-cada-partit"])
      });
    }
  